import React, { Component } from 'react';
import { apiPost, apiGet } from '../../Api';

export default class DamageTypeDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imageFile: null,
            imagePreviewUrl: '',
            damagetype: null
        };
    }


    componentDidUpdate = async (prevProps, prevState) => {
        console.log("update");
        if (this.props.damagetypeId !== prevProps.damagetypeId || this.props.creatingNewDamageType !== prevProps.creatingNewDamageType) {
            this.setState({ imageFile: null, imagePreviewUrl: null });
            this.getDamageType();

        }
    }


    getDamageType = async () => {
        if (this.props.damagetypeId != null) {
            if (this.props.damagetypeId === "") {
                // this.setState({ damagetype: null });
                this.setState({ damagetype: { name: "", shortName: "", imageId: "" }, imageFile: null, imagePreviewUrl: "" });
            }
            else {
                const response = await apiGet("/damagetype/" + this.props.damagetypeId);
                if (response.ok) {
                    const curr = await response.json();
                    this.setState({ damagetype: curr });
                    if (curr.imageId) {
                        this.fetchImage();
                    }
                }
            }
        }
        else {
            this.setState({ damagetype: null });
        }
    }

    handleInputChange = (event) => {
        const name = event.target.name;
        let value = event.target.value;
        if (event.target.type === "checkbox") {
            value = event.target.checked;
        }
        const damagetype = { ...this.state.damagetype, [name]: value };
        this.setState({ damagetype });
    };




    render() {
        const { onUpdate, onDelete, onCreate, creatingNewDamageType, onCancelCreate } = this.props;
        const { damagetype, imagePreviewUrl } = this.state;

        if (!damagetype || damagetype == null) return <div>Select a damagetype to see details</div>;

        return (
            <div className='admin_details'>
                <label>Name:
                    <input type="text" name="name" value={damagetype.name} onChange={this.handleInputChange} />
                </label>
                <label>colorHex:
                    <input type="text" name="colorHex" value={damagetype.colorHex} onChange={this.handleInputChange} />
                    <div style={{ width: '100px', height: '10px', backgroundColor: damagetype.colorHex }}></div>
                </label>

                {creatingNewDamageType ?
                    <div>
                        {/* Form to create a new damagetype, similar to the update form... */}
                        <button onClick={() => onCreate(damagetype)}>Create</button>
                        <button onClick={() => onCancelCreate()}>Cancel</button>
                    </div>
                    :
                    <div>
                        <button onClick={() => onUpdate(damagetype)}>Update</button>
                        <button onClick={() => onDelete(damagetype)}>Delete</button>
                    </div>
                }


            </div>
        );


    }

}